/**
 * ReportSummaryCards Component - Summary statistics cards for different report types
 */
import React from 'react';
import { Card, CardContent } from '../ui/card';
import { 
  User, 
  CheckCircle, 
  AlertTriangle, 
  XCircle, 
  BarChart3,
  Clock,
  FileText
} from 'lucide-react';
import { colors } from './constants';

export const GesamtSummaryCards = ({ summary, excludedCount }) => (
  <>
    <Card className="bg-white border-l-4 border-l-blue-500" style={{ borderColor: colors.border }}>
      <CardContent className="pt-4">
        <div className="text-center">
          <User className="h-6 w-6 mx-auto mb-1" style={{ color: colors.blue }} />
          <div className="text-2xl font-bold" style={{ color: colors.dark }}>
            {summary?.total_users || 0}
          </div>
          <div className="text-xs" style={{ color: colors.gray }}>Benutzer</div>
          {excludedCount > 0 && (
            <div className="text-xs mt-1 text-red-500">
              Administratoren ({excludedCount})
            </div>
          )}
        </div>
      </CardContent>
    </Card>
    <Card className="bg-white border-l-4 border-l-green-500" style={{ borderColor: colors.border }}>
      <CardContent className="pt-4">
        <div className="text-center">
          <CheckCircle className="h-6 w-6 mx-auto text-green-500 mb-1" />
          <div className="text-2xl font-bold text-green-600">
            {summary?.completed || 0}
          </div>
          <div className="text-xs" style={{ color: colors.gray }}>Gültig</div>
        </div>
      </CardContent>
    </Card>
    <Card className="bg-white border-l-4 border-l-red-500" style={{ borderColor: colors.border }}>
      <CardContent className="pt-4">
        <div className="text-center">
          <AlertTriangle className="h-6 w-6 mx-auto text-red-500 mb-1" />
          <div className="text-2xl font-bold text-red-600">
            {summary?.expired || 0}
          </div>
          <div className="text-xs" style={{ color: colors.gray }}>Abgelaufen</div>
        </div>
      </CardContent>
    </Card>
    <Card className="bg-white border-l-4 border-l-orange-500" style={{ borderColor: colors.border }}>
      <CardContent className="pt-4">
        <div className="text-center">
          <XCircle className="h-6 w-6 mx-auto text-orange-500 mb-1" />
          <div className="text-2xl font-bold text-orange-600">
            {summary?.not_completed || 0}
          </div>
          <div className="text-xs" style={{ color: colors.gray }}>Offen</div>
        </div>
      </CardContent>
    </Card>
    <Card className="bg-white border-l-4 border-l-purple-500" style={{ borderColor: colors.border }}>
      <CardContent className="pt-4">
        <div className="text-center">
          <BarChart3 className="h-6 w-6 mx-auto text-purple-500 mb-1" />
          <div className="text-2xl font-bold text-purple-600">
            {summary?.completion_rate || 0}%
          </div>
          <div className="text-xs" style={{ color: colors.gray }}>Abschlussrate</div>
        </div>
      </CardContent>
    </Card>
  </>
);

export const AblaufSummaryCards = ({ summary }) => (
  <>
    <Card className="bg-white border-l-4 border-l-red-500" style={{ borderColor: colors.border }}>
      <CardContent className="pt-4">
        <div className="text-center">
          <AlertTriangle className="h-6 w-6 mx-auto text-red-500 mb-1" />
          <div className="text-2xl font-bold text-red-600">
            {summary?.expired || 0}
          </div>
          <div className="text-xs" style={{ color: colors.gray }}>Abgelaufen</div>
        </div>
      </CardContent>
    </Card>
    <Card className="bg-white border-l-4 border-l-amber-500" style={{ borderColor: colors.border }}>
      <CardContent className="pt-4">
        <div className="text-center">
          <Clock className="h-6 w-6 mx-auto text-amber-500 mb-1" />
          <div className="text-2xl font-bold text-amber-600">
            {summary?.expiring_soon || 0}
          </div>
          <div className="text-xs" style={{ color: colors.gray }}>Läuft bald ab</div>
        </div>
      </CardContent>
    </Card>
    <Card className="bg-white border-l-4 border-l-green-500" style={{ borderColor: colors.border }}>
      <CardContent className="pt-4">
        <div className="text-center">
          <CheckCircle className="h-6 w-6 mx-auto text-green-500 mb-1" />
          <div className="text-2xl font-bold text-green-600">
            {summary?.valid || 0}
          </div>
          <div className="text-xs" style={{ color: colors.gray }}>Gültig</div>
        </div>
      </CardContent>
    </Card>
    <Card className="bg-white border-l-4 border-l-gray-500" style={{ borderColor: colors.border }}>
      <CardContent className="pt-4">
        <div className="text-center">
          <FileText className="h-6 w-6 mx-auto text-gray-500 mb-1" />
          <div className="text-2xl font-bold text-gray-600">
            {summary?.no_expiry_date || 0}
          </div>
          <div className="text-xs" style={{ color: colors.gray }}>Kein Ablaufdatum</div>
        </div>
      </CardContent>
    </Card>
  </>
);
